import io from 'socket.io-client';

const connectionOptions = {
  forceNew: true,
  rejectUnauthorized: false,
  reconnection: true,
  reconnectionAttempts: 'Infinity',
  timeout: 5000,
  transports: ['websocket'],
  // path: '/agent_status/socket.io',
  // autoConnect: false,
};

function connectSocket(token) {
  const socket = io(
    `wss://wss-agents.nuacom.net/agent_status?socket_for=agent_status&client-security-token=${token}`,
    connectionOptions
  );

  return socket;
}

export { connectSocket };
